import SearchTitle from './SearchTitle';

export default SearchTitle;
